<div style="background-color: #303845; height: auto;" class="xl:h-20rem">
    <div class="grid justify-content-center align-items-start align-content-end">
        <div class="col-12 md:col-6 lg:col-4 align-items-start">
            <div class="col-12">
                <div class="border-round-sm"
                     style="color: white; margin-left: 80px; font-size:1.2rem">
                    <i class="pi pi-map-marker"></i> &nbsp; Dirección de Ordenamiento Territorial y Construcción<br>
                    Edificio Terranostra, 43a. Avenida Norte y 1ra. Calle Poniente (Complejo CNR), San Salvador Centro, San Salvador.
                </div>
            </div>
            <div class="col-12">
                <div class="border-round-sm"
                     style="color: white; margin-left: 80px; font-size:1.2rem">

                    <i class="pi pi-phone"></i> &nbsp; 2267-7250 | 7986-0005 | 7986-0006
                    - Atención al Usuario
                </div>
            </div>
            <div class="col-12">
                <div class="border-round-sm"
                     style="color: white; margin-left: 80px; font-size:1.2rem">
                    <i class="pi pi-globe"></i> &nbsp; <a style="color: white;" href="https://dot.gob.sv/">Sitio
                    oficial</a>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <div class="text-center border-round-sm font-bold">
                <div class="row overflow-hidden">
                    <div class="col-12" style="text-align: center;">
                        <p-image src="../../../../../assets/demo/images/logos/dot_logo.png" alt="Image"
                                 width="150" [ngStyle]="{'filter': 'invert(1) brightness(2)'}"></p-image>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <div class="text-center p-3 border-round-sm font-bold"></div>
        </div>
    </div>
</div>
